
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'

function formatJsonToArray(jsonData, keyArray, headerArray) {
  return jsonData.map(item => {
    return keyArray.map(key => {
      if (key.includes('.')) {
        const keys = key.split('.')
        return keys.reduce((obj, k) => (obj !== null && obj !== undefined ? obj[k] : null), item)
      }
      return item[key] !== undefined && item[key] !== null ? item[key] : ''
    })
  })
}

export function exportJsonToExcel(options) {
  const {
    header = [],  
    data,        
    key,          
    filename = 'excel-list',  
    autoWidth = true,  
    bookType = 'xlsx',  
    merges = []   
  } = options

  const wsData = [header]
  const dataArray = formatJsonToArray(data, key, header)
  wsData.push(...dataArray)

  const ws = XLSX.utils.aoa_to_sheet(wsData)

  if (autoWidth) {
    const colWidths = header.map((h, i) => {
      const maxLength = Math.max(
        ...dataArray.map(row => {
          const val = row[i]
          return val !== undefined && val !== null ? val.toString().length : 0
        }),
        header[i].length
      )
      return { wch: Math.min(Math.max(maxLength + 2, 10), 50) } 
    })
    ws['!cols'] = colWidths
  }

  if (merges && merges.length > 0) {
    ws['!merges'] = merges
  }


  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')


  const wbout = XLSX.write(wb, { 
    bookType, 
    type: 'array',
    cellDates: true 
  })
  
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${filename}.${bookType}`)
}


export function formatDate(date, fmt = 'yyyy-MM-dd') {
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, 
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return fmt
}

export default {
  exportJsonToExcel,
  formatDate
}


// WEBPACK FOOTER //
// ./src/until/export2Excel.js